var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInbox = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M.667 8c0-.368.298-.667.666-.667h4c.223 0 .431.112.555.297l1.136 1.703h1.953l1.135-1.703a.667.667 0 0 1 .555-.297h4a.667.667 0 1 1 0 1.334h-3.643L9.888 10.37a.667.667 0 0 1-.555.297H6.667a.667.667 0 0 1-.555-.297L4.977 8.667H1.333A.667.667 0 0 1 .667 8Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.827 2h6.346a2.001 2.001 0 0 1 1.79 1.11l2.3 4.592c.046.092.07.194.07.298v4a2 2 0 0 1-2 2H2.667a2 2 0 0 1-2-2V8c0-.104.024-.206.07-.298l2.3-4.592v-.001A2 2 0 0 1 4.827 2ZM3.633 3.407l.597.298L2 8.158V12a.667.667 0 0 0 .667.667h10.666A.667.667 0 0 0 14 12V8.158l-2.23-4.453v-.002a.666.666 0 0 0-.597-.37H4.827a.667.667 0 0 0-.597.37l-.597-.296Z",
  clipRule: "evenodd"
})));
SvgInbox.viewBox = '0 0 16 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgInbox);
export default ForwardRef;